// import React, { useEffect, useState } from "react";
import HomeBanner from "../components/HomeBanner";
import FeatureProducts from "../components/FeatureProducts";
import WhoWeAre from "../components/WhoWeAre";
import OurPartners from "../components/OurPartners";
import WhatWeDo from "../components/WhatWeDo";
// import OurTeam from "../components/OurTeam";

const Home = () => {
  return (
    <>
      <HomeBanner />
      <WhoWeAre />
      <OurPartners />
      <WhatWeDo />
      {/* <OurTeam /> */}
      <FeatureProducts />
    </>
  );
};

export default Home;
